import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { setResidentDiscount } from '../../redux/currentSearch/actions';
import { getResidentDiscountProps } from '../../redux/currentSearch/selectors';

export const ResidentDiscount = ({
    checked,
    children,
    hasNonAdults,
    regions,
    setResidentDiscount,
}) => {
    const { t } = useTranslation();
    const onChange = () => setResidentDiscount(!checked);

    const hasRegions = regions.length > 0;

    const regionsText = regions
        .map((region) => {
            return ` ${region.charAt(0).toUpperCase()}${region.slice(1).toLowerCase()}`;
        })
        .join(` ${t('flightsManager.residentDiscount.oneliner.field.separator')}`);

    return children({ checked, hasNonAdults, hasRegions, onChange, regionsText });
};

ResidentDiscount.propTypes = {
    checked: PropTypes.bool.isRequired,
    children: PropTypes.func.isRequired,
    hasNonAdults: PropTypes.bool.isRequired,
    regions: PropTypes.arrayOf(PropTypes.string).isRequired,
    setResidentDiscount: PropTypes.func.isRequired,
};

const ConnectedResidentDiscount = connect(getResidentDiscountProps, {
    setResidentDiscount,
})(ResidentDiscount);

export { ConnectedResidentDiscount };
